import { useApolloClient } from '@apollo/client'
import { jwtDecode } from 'jwt-decode'
import { useEffect } from 'react'
import { MINUTE } from 'time-constants'
import { TOKEN_KEY } from '@/config/local-storage'
import { gql } from '@/lib/graphql/gql'
import type {
  GetNewTokenMutation,
  GetNewTokenMutationVariables,
} from '@/components/auth/token-updater.types.gen'

const GET_NEW_TOKEN_MUTATION = gql`
  mutation GetNewToken($token: String!) {
    getNewToken(token: $token) {
      newToken
    }
  }
`
const CHECKING_INTERVAL = MINUTE
const UPDATE_INTERVAL = 30 * MINUTE

const isTokenUpToDate = (): boolean => {
  const { iat: issuedAt } = jwtDecode<{ iat: number }>(
    localStorage.getItem(TOKEN_KEY) || ''
  )
  const issuedAtMilliseconds = issuedAt * 1000
  return issuedAtMilliseconds > Date.now() - UPDATE_INTERVAL
}

export const TokenUpdater = () => {
  const client = useApolloClient()

  useEffect(() => {
    const idInterval = setInterval(async () => {
      if (localStorage.getItem(TOKEN_KEY) && !isTokenUpToDate()) {
        const result = await client
          .mutate<GetNewTokenMutation, GetNewTokenMutationVariables>({
            mutation: GET_NEW_TOKEN_MUTATION,
            variables: { token: localStorage.getItem(TOKEN_KEY) || '' },
          })
          .catch(() => ({ data: { getNewToken: { newToken: null } } }))

        const newToken = result?.data?.getNewToken?.newToken
        if (newToken) {
          localStorage.setItem(TOKEN_KEY, newToken)
          window.dispatchEvent(new CustomEvent('token-updated'))
        }
      }
    }, CHECKING_INTERVAL)

    return () => {
      if (idInterval) {
        clearInterval(idInterval)
      }
    }
  }, [client])

  return null
}
